import React from 'react';
import { Link } from 'react-router-dom';
import './projectorProduct.css';

const ProjectorProduct = () => {
    const projectors = [
        {
            number: '01',
            title: '고광량 빔프로젝터 01',
            image: '/images/product/projector/projector-01.png',
            description: '대형 행사와 세미나, 기업행사 등 다양한 현장에서 활용할 수 있는 고광량 빔프로젝터입니다.'
        },
        {
            number: '02',
            title: '고광량 빔프로젝터 02',
            image: '/images/product/projector/projector-02.png',
            description: '컨퍼런스와 전시, 발표회 등 선명한 영상 표현이 필요한 공간에 적합한 빔프로젝터입니다.'
        },
        {
            number: '03',
            title: '고광량 빔프로젝터 03',
            image: '/images/product/projector/projector-03.png',
            description: '넓은 공간과 다양한 행사 환경에서 안정적인 영상 송출을 지원하는 빔프로젝터입니다.'
        }
    ];

    const features = [
        {
            icon: 'mdi-white-balance-sunny',
            title: '고광량 지원',
            description: '다양한 행사 환경을 고려한 밝기의 프로젝터를 제공합니다.'
        },
        {
            icon: 'mdi-monitor',
            title: '다양한 화면 구성',
            description: '행사 공간과 목적에 맞는 화면 환경을 구성합니다.'
        },
        {
            icon: 'mdi-cog-outline',
            title: '행사용 최적 구성',
            description: '공간과 목적에 맞는 장비와 스크린을 구성합니다.'
        },
        {
            icon: 'mdi-tools',
            title: '전문 기술 지원',
            description: '설치부터 행사 운영까지 전문 인력이 지원합니다.'
        }
    ];

    const rentalPoints = [
        {
            icon: 'mdi-monitor',
            title: '선명한 영상',
            description: '행사 환경에 적합한 장비를 구성하여 안정적인 화면을 제공합니다.'
        },
        {
            icon: 'mdi-cog-outline',
            title: '행사 맞춤 세팅',
            description: '행사 공간과 목적에 맞춰 프로젝터와 스크린을 구성합니다.'
        },
        {
            icon: 'mdi-clipboard-check-outline',
            title: '전문 설치 · 운영',
            description: '경험 많은 전문 인력이 설치부터 행사 운영까지 지원합니다.'
        },
        {
            icon: 'mdi-headset',
            title: '안정적인 현장 지원',
            description: '행사 진행 중 발생할 수 있는 상황에 신속하게 대응합니다.'
        }
    ];

    return (
        <div className="projector-product">

            {/* SUB VISUAL */}
            <section className="projector-sub-visual">
                <div className="projector-sub-overlay"></div>

                <div className="projector-sub-inner">
                    <p>PRODUCT</p>

                    <h1>빔프로젝터</h1>

                    <div className="projector-breadcrumb">
                        <Link to="/">
                            HOME
                        </Link>

                        <span>›</span>
                        <span>제품소개</span>
                        <span>›</span>

                        <strong>
                            빔프로젝터
                        </strong>
                    </div>
                </div>
            </section>

            {/* FEATURE */}
            <section className="projector-feature">
                <div className="projector-feature-inner">
                    {features.map((feature) => (
                        <div
                            className="projector-feature-item"
                            key={feature.title}
                        >
                            <div className="projector-feature-icon">
                                <i className={`mdi ${feature.icon}`}></i>
                            </div>

                            <div>
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* LINEUP */}
            <section className="projector-lineup">
                <div className="projector-container">

                    <div className="projector-lineup-header">
                        <p>PROJECTOR LINEUP</p>

                        <h2>빔프로젝터 라인업</h2>

                        <span>
                            세미나, 컨퍼런스, 기업행사, 전시 등
                            <br />
                            다양한 행사 환경에 적합한 빔프로젝터를 제공합니다.
                        </span>
                    </div>

                    <div className="projector-list">
                        {projectors.map((projector) => (
                            <article
                                className="projector-card"
                                key={projector.number}
                            >
                                <div className="projector-card-image">
                                    <img
                                        src={projector.image}
                                        alt={projector.title}
                                    />
                                </div>

                                <div className="projector-card-content">
                                    <span className="projector-card-number">
                                        {projector.number}
                                    </span>

                                    <h3>{projector.title}</h3>

                                    <p>
                                        {projector.description}
                                    </p>

                                    <Link
                                        to="/inquiry"
                                        className="projector-card-link"
                                    >
                                        렌탈 문의하기

                                        <i className="mdi mdi-arrow-right"></i>
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>

                </div>
            </section>

            {/* RENTAL POINT */}
            <section className="projector-rental-point">
                <div className="projector-point-overlay"></div>

                <div className="projector-container projector-point-inner">

                    <div className="projector-point-title">
                        <p>RENTAL POINT</p>

                        <h2>
                            왜 MTMEDIA<br />
                            빔프로젝터인가요?
                        </h2>

                        <span>
                            다양한 행사 경험을 바탕으로
                            <br />
                            안정적인 장비와 전문적인 운영을 제공합니다.
                        </span>
                    </div>

                    <div className="projector-point-list">
                        {rentalPoints.map((point) => (
                            <div
                                className="projector-point-item"
                                key={point.title}
                            >
                                <div className="projector-point-icon">
                                    <i className={`mdi ${point.icon}`}></i>
                                </div>

                                <div>
                                    <h3>{point.title}</h3>
                                    <p>{point.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* USE CASE */}
            <section className="projector-use">
                <div className="projector-container">

                    <div className="projector-section-title">
                        <p>APPLICATION</p>
                        <h2>다양한 행사 현장에서 활용됩니다</h2>
                        <span>
                            행사 규모와 공간에 맞는 빔프로젝터와
                            스크린 구성을 제안합니다.
                        </span>
                    </div>

                    <div className="projector-use-list">

                        <div className="projector-use-item">
                            <span>01</span>
                            <h3>세미나 · 컨퍼런스</h3>
                            <p>
                                발표 자료와 영상 콘텐츠를
                                선명하게 전달할 수 있도록 구성합니다.
                            </p>
                        </div>

                        <div className="projector-use-item">
                            <span>02</span>
                            <h3>기업행사</h3>
                            <p>
                                기업 행사와 사내 이벤트의 규모에 맞춰
                                영상 장비를 구성합니다.
                            </p>
                        </div>

                        <div className="projector-use-item">
                            <span>03</span>
                            <h3>전시 · 행사</h3>
                            <p>
                                전시 공간과 콘텐츠 특성에 맞는
                                프로젝터 환경을 제공합니다.
                            </p>
                        </div>

                        <div className="projector-use-item">
                            <span>04</span>
                            <h3>발표회 · 교육</h3>
                            <p>
                                발표와 교육 현장에서 안정적인
                                영상 송출 환경을 지원합니다.
                            </p>
                        </div>

                    </div>

                </div>
            </section>

            {/* CTA */}
            <section className="projector-contact">
                <div className="projector-contact-overlay"></div>

                <div className="projector-contact-inner">
                    <p>MTMEDIA CONSULTING</p>

                    <h2>
                        어떤 빔프로젝터가<br />
                        적합한지 고민되시나요?
                    </h2>

                    <span>
                        행사 장소와 규모, 사용 목적을 알려주시면
                        <br />
                        현장에 적합한 장비를 안내해드립니다.
                    </span>

                    <Link
                        to="/inquiry"
                        className="projector-contact-button"
                    >
                        견적문의 하기

                        <i className="mdi mdi-arrow-right"></i>
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default ProjectorProduct;